import { createRouter, createWebHistory } from 'vue-router'
import Login from '@/components/login/login.vue'
import RecoverPassword from '@/components/login/recover.vue'
import RegisterPassword from '@/components/login/register.vue'
import Application from '@/components/application/application.vue'
import Bases from '@/components/dashboard/bases.vue'
import BracketMeasureUnits from '@/components/dashboard/bracket_measure_units.vue'
import ClonePriceList from '@/components/dashboard/clone_price_list.vue'
import Customers from '@/components/dashboard/customers.vue'
import EquipmentSizes from '@/components/dashboard/equipment_sizes.vue'
import Formulas from '@/components/dashboard/formulas.vue'
import GoodsKinds from '@/components/dashboard/goods_kinds.vue'
import Logout from '@/components/login/logout.vue'
import MeasureUnits from '@/components/dashboard/measure_units.vue'
import Nations from '@/components/dashboard/nations.vue'
//import Operators from '@/components/dashboard/operators.vue'
import PackagesKinds from '@/components/dashboard/packages_kinds.vue'
import Locations from '@/components/dashboard/locations.vue'
import PriceLists from '@/components/dashboard/price_lists.vue'
//import Suppliers from '@/components/dashboard/suppliers.vue'
import Quote from '@/components/dashboard/quote.vue'

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/recover',
    name: 'recover',
    component: RecoverPassword
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterPassword
  },
  {    
    path: '/application',
    name: 'application',
    component: Application,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    children: [
      {
        component: Bases,
        name: 'bases',
        path: 'bases', // Relative path
      },
      {
        component: BracketMeasureUnits,
        name: 'bracket_measure_units',
        path: 'bracket_measure_units', // Relative path
      },
      {
        component: ClonePriceList,
        name: 'clone_price_list',
        path: 'clone_price_list', // Relative path
      },
      {
        component: Customers,
        name: 'customers',
        path: 'customers', // Relative path
      },
      {
        component: EquipmentSizes,
        name: 'equipment_sizes',
        path: 'equipment_sizes', // Relative path
      },
      {
        component: Formulas,
        name: 'formulas',
        path: 'formulas', // Relative path
      },
      {
        component: GoodsKinds,
        name: 'goods_kinds',
        path: 'goods_kinds', // Relative path
      },
      //{
      //  component: Logout,
      //  name: 'logout',
      //  path: 'logout', // Relative path
      //},
      {
        component: MeasureUnits,
        name: 'measure_units',
        path: 'measure_units', // Relative path
      },
      {
        component: Nations,
        name: 'nations',
        path: 'nations', // Relative path
      },
      {
        component: PackagesKinds,
        name: 'packages_kinds',
        path: 'packages_kinds', // Relative path
      },
      {
        component: Locations,
        name: 'locations',
        path: 'locations', // Relative path
      },
      {
        component: PriceLists,
        name: 'price_lists',
        path: 'price_lists', // Relative path
      },
      {
        component: Quote,
        name: 'quote',
        path: 'quote', // Relative path
      },
    ]
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
